// extracted by mini-css-extract-plugin
export default {"geoMap":"DivisionVehicleMapWidget_geoMap__b2HaX"};